"use client";
import Logo from "@/app/(ui)/components/Layout/Header/Logo";
import RazorpayButton from "@/app/(ui)/components/Home/Hero/RazorPay";

export function Donation() {
  return (
    <>
      <div className="mb-7 mx-auto text-center sm:max-w-55 md:max-w-75 lg:max-w-100">
        <Logo />
      </div>
      <h2 className="text-xl font-semibold mb-4 text-title">Donate Now</h2>
      <RazorpayButton />
    </>
  );
}
